import { Alert, Snackbar } from "@mui/material";
import { Modal, Popin, Text } from "$components";
import DockyardForm from "../../DockyardForm";
import { useStyles } from "../styles";
import { DockyardDetailsLogic } from "../types";

type DockyardModalsProps = Pick<
  DockyardDetailsLogic,
  | "modalActive"
  | "setModalActive"
  | "isDockyardDisabled"
  | "EnableDockyard"
  | "DisableDockyard"
  | "modal"
  | "setModal"
  | "handleClickTerminate"
  | "isOpened"
  | "togglePopin"
  | "dockyardFormClasses"
  | "formDockyard"
  | "handleSubmit"
  | "error"
  | "submitting"
  | "modalDeleteOpen"
  | "setModalDeleteOpen"
  | "handleDeleteDockyard"
  | "errorMessage"
  | "handleCloseError"
>;

export default function DockyardModals({
  modalActive,
  setModalActive,
  isDockyardDisabled,
  EnableDockyard,
  DisableDockyard,
  modal,
  setModal,
  handleClickTerminate,
  isOpened,
  togglePopin,
  dockyardFormClasses,
  formDockyard,
  handleSubmit,
  error,
  submitting,
  modalDeleteOpen,
  setModalDeleteOpen,
  handleDeleteDockyard,
  errorMessage,
  handleCloseError,
}: DockyardModalsProps) {
  const classes = useStyles();

  return (
    <>
      <Modal
        open={modalActive}
        onCancel={() => setModalActive(false)}
        className={classes.modal}
        title="Attention"
        textValidate={isDockyardDisabled ? "Activer" : "Désactiver"}
        onConfirm={isDockyardDisabled ? EnableDockyard : DisableDockyard}
      >
        <div className={classes.ModalContainer}>
          {`Vous êtes sur le point de ${
            isDockyardDisabled ? "réactiver" : "désactiver"
          } ce chantier, êtes-vous sûr de vouloir continuer ?`}
        </div>
      </Modal>

      <Modal
        open={modal}
        onCancel={() => setModal(false)}
        className={classes.modal}
        title="Attention"
        textValidate="Chantier terminé"
        onConfirm={handleClickTerminate}
      >
        <div className={classes.ModalContainer}>
          Vous êtes sur le point de marquer votre chantier comme “Terminé”.
          Êtes-vous sûr de vouloir confirmer cette action ?
        </div>
      </Modal>

      <Popin
        className={dockyardFormClasses.ProjectsPage_Popin}
        openPopin={isOpened}
        toggleDrawer={togglePopin}
      >
        <DockyardForm
          dockyard={formDockyard}
          defaultValuesForm={null}
          onSubmit={handleSubmit}
          onCancel={() => togglePopin(false)}
          error={error}
          isSubmitting={submitting}
        />
      </Popin>

      <Modal
        open={modalDeleteOpen}
        onCancel={() => setModalDeleteOpen(false)}
        onValidate={async () => {
          setModalDeleteOpen(false);
          await handleDeleteDockyard();
        }}
        textCancel="Annuler"
        textValidate="Supprimer"
      >
        <div style={{ textAlign: "center" }}>
          <Text>
            Vous êtes sur le point de supprimer définitivement ce chantier.
            <br />
            Êtes-vous sûr de vouloir continuer ?
          </Text>
        </div>
      </Modal>

      <Snackbar
        open={!!errorMessage}
        autoHideDuration={6000}
        onClose={handleCloseError}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseError}
          severity="error"
          sx={{ width: "100%", fontSize: "14px" }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
}
